const ADMIN_CONSENT_ROUTE_PREFIX = "/auth/admin-consent/";

const stripQueryAndHash = (path: string) =>
  path.split("#", 1)[0]?.split("?", 1)[0] ?? "";

export const isAdminConsentRoute = (path: string) =>
  stripQueryAndHash(path).startsWith(ADMIN_CONSENT_ROUTE_PREFIX);
